import { render, staticRenderFns } from "./Paragraphs.vue?vue&type=template&id=fd3d653a&"
import script from "./Paragraphs.vue?vue&type=script&lang=js&"
export * from "./Paragraphs.vue?vue&type=script&lang=js&"
import style0 from "./Paragraphs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports